import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IStatuses, defaultValue } from 'app/shared/model/statuses.model';

export const ACTION_TYPES = {
  FETCH_STATUSES_LIST: 'statuses/FETCH_STATUSES_LIST',
  FETCH_STATUSES: 'statuses/FETCH_STATUSES',
  CREATE_STATUSES: 'statuses/CREATE_STATUSES',
  UPDATE_STATUSES: 'statuses/UPDATE_STATUSES',
  DELETE_STATUSES: 'statuses/DELETE_STATUSES',
  RESET: 'statuses/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IStatuses>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type StatusesState = Readonly<typeof initialState>;

// Reducer

export default (state: StatusesState = initialState, action): StatusesState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_STATUSES_LIST):
    case REQUEST(ACTION_TYPES.FETCH_STATUSES):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_STATUSES):
    case REQUEST(ACTION_TYPES.UPDATE_STATUSES):
    case REQUEST(ACTION_TYPES.DELETE_STATUSES):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_STATUSES_LIST):
    case FAILURE(ACTION_TYPES.FETCH_STATUSES):
    case FAILURE(ACTION_TYPES.CREATE_STATUSES):
    case FAILURE(ACTION_TYPES.UPDATE_STATUSES):
    case FAILURE(ACTION_TYPES.DELETE_STATUSES):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_STATUSES_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_STATUSES):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_STATUSES):
    case SUCCESS(ACTION_TYPES.UPDATE_STATUSES):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_STATUSES):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/statuses';

// Actions

export const getEntities: ICrudGetAllAction<IStatuses> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_STATUSES_LIST,
  payload: axios.get<IStatuses>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IStatuses> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_STATUSES,
    payload: axios.get<IStatuses>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IStatuses> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_STATUSES,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IStatuses> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_STATUSES,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IStatuses> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_STATUSES,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
